// UTM helpers — capture from URL, persist to sessionStorage so they survive
// across navigation within the site, then attach to inquiry submissions.

const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE = "sfs_attribution";

export function captureUTMFromURL() {
  if (typeof window === "undefined") return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let any = false;
    for (const k of KEYS) {
      const v = params.get(k);
      if (v) {
        found[k] = v.slice(0, 120);
        any = true;
      }
    }
    if (!any) return readStored();
    const stored = readStored();
    const next = {
      ...stored,
      ...found,
      landing_page: stored.landing_page || window.location.pathname,
      referrer: stored.referrer || (document.referrer || "").slice(0, 250) || undefined,
    };
    sessionStorage.setItem(STORAGE, JSON.stringify(next));
    return next;
  } catch {
    return {};
  }
}

export function readStored() {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function setLandingPersona(persona) {
  if (typeof window === "undefined") return;
  try {
    const stored = readStored();
    if (stored.persona) return; // first-touch wins
    const next = {
      ...stored,
      persona,
      landing_page: stored.landing_page || window.location.pathname,
      referrer: stored.referrer || (document.referrer || "").slice(0, 250) || undefined,
    };
    sessionStorage.setItem(STORAGE, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}

export function getAttribution() {
  return readStored();
}
